module.exports = __webpack_public_path__ + "img/share-circle.88c67fc3.svg";